import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { STEPS } from "@/lib/media";
import { Reveal } from "./Reveal";

function StickyNumber({ progress, index, total, num }) {
  const start = index / total;
  const end = (index + 1) / total;
  const opacity = useTransform(progress, [start - 0.08, start, end - 0.05, end], [0, 1, 1, 0]);
  return (
    <motion.div style={{ opacity }} className="absolute inset-0 font-display text-gold text-[9rem] leading-none">
      {num}
    </motion.div>
  );
}

export default function HowItWorks() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end end"] });

  return (
    <section id="process" ref={ref} className="relative bg-ink" data-testid="how-it-works">
      <div className="max-w-[1500px] mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-2 gap-12">
          {/* Sticky left */}
          <div className="md:sticky md:top-0 md:h-screen flex flex-col justify-center py-20">
            <Reveal>
              <span className="font-serif italic text-gold tracking-[0.25em] text-sm">The Process</span>
              <h2 className="font-display uppercase text-cream leading-[0.9] tracking-tight text-5xl md:text-7xl mt-4">
                From Booking <br /> To Report
              </h2>
              <p className="text-cream/60 mt-6 max-w-md leading-relaxed">
                A choreographed inspection built for discerning homeowners. Four exacting stages,
                one uncompromising standard of certainty.
              </p>
            </Reveal>

            <div className="relative mt-12 h-24 hidden md:block">
              {STEPS.map((s, i) => (
                <StickyNumber key={s.num} progress={scrollYProgress} index={i} total={STEPS.length} num={s.num} />
              ))}
            </div>
          </div>

          {/* Scrolling right */}
          <div className="py-20 md:py-40 flex flex-col gap-20 md:gap-40">
            {STEPS.map((s) => (
              <Reveal key={s.num} className="border-l border-gold/40 pl-8">
                <div className="font-display text-gold/80 text-6xl md:hidden mb-4">{s.num}</div>
                <div className="font-display uppercase tracking-[0.2em] text-gold text-xs mb-3">
                  Step {s.num}
                </div>
                <h3 className="font-display uppercase text-cream text-3xl md:text-4xl tracking-tight leading-tight">
                  {s.title}
                </h3>
                <p className="text-cream/60 mt-4 leading-relaxed text-lg">{s.desc}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
